import { render, staticRenderFns } from "./VueDatepickerLocal.vue?vue&type=template&id=8288d3c8"
import script from "./VueDatepickerLocal.vue?vue&type=script&lang=js"
export * from "./VueDatepickerLocal.vue?vue&type=script&lang=js"
import style0 from "./VueDatepickerLocal.vue?vue&type=style&index=0&id=8288d3c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports